import React, { useState, useEffect } from 'react'
import { useCamera } from '../components/CameraContext';
import { useNavigate } from "react-router-dom";
import './Navbar.css'
import NavMobile from './NavMobile';

const Navbar = ({
  lang, setLang,
  isStart, ScenairoStop,
  navContent, setNavContent, isOverlayContentVisible, isWorkInlineContainerVisible,
  OpenContent, OpenHome, OpenAbout, OpenWork, OpenContact, Close,
  isOpenAnimComplete,
  isModelLoaded, scenarioStep,
  isMute, setMute }) => {
  // const { setMoveToCamera } = useCamera();

  const [isMobile, setMobile] = useState(false);
  const [isNavOpen, setNavOpen] = useState(false);

  const navStyle = {
    top: isOpenAnimComplete ? isWorkInlineContainerVisible ? '-96px' : '0px' : '-96px',
    opacity: isWorkInlineContainerVisible ? 0 : 1,
    pointerEvents: isWorkInlineContainerVisible ? 'none' : 'auto'
  }
  const navLogoHitboxStyle = {
    pointerEvents: isOverlayContentVisible ? 'none' : (isStart ? 'auto' : 'none')
  }

  const navRightStyle = {
    opacity: isOverlayContentVisible ? 0 : 1,
    pointerEvents: isOverlayContentVisible ? 'none' : 'all'
  }

  const closeBtnStyle = {
    opacity: isOverlayContentVisible ? 1 : 0,
    pointerEvents: isOverlayContentVisible ? (isWorkInlineContainerVisible ? 'none' : 'all') : 'none'
  }

  const navLeftStyle = {
    backgroundColor: isMobile ? '#ffffff' : '#ffffff',
    pointerEvents: isWorkInlineContainerVisible ? 'none' : 'auto',
  }

  const closeSubToMain = () => {
    Close();
    setNavContent('');
    // setMoveToCamera("main");

    // console.log("to main");

    //* 피날레 일 때
    if (scenarioStep === 21) {
      // console.log('scenairo 21, close nav');
      ScenairoStop();
    }
  };

  const checkMobile = () => {
    if (window.innerWidth <= 720) {
      setMobile(true);
    } else {
      setMobile(false);
    }
  }

  const onClickMenu = (target) => {
    console.log("target!!!!!!!!!!!!!! ", target)
    if (target === "home") {
      OpenHome();
    } else {
      setNavContent(target);
      // setMoveToCamera(target);
      OpenContent();
      switch (target) {
        case "about":
          OpenAbout();
          break;
        case "work":
          OpenWork();
          break;
        case "contact":
          OpenContact();
          break;
        default:
          break;
      }
    }
  }

  useEffect(() => {
    const handleCloseSubToMain = () => {
      if (navContent !== "")
        setNavContent('');
    };
    checkMobile();
    window.addEventListener('closeSubToMain', handleCloseSubToMain);
    window.addEventListener('resize', checkMobile);
    return () => {
      window.removeEventListener('closeSubToMain', handleCloseSubToMain);
      window.removeEventListener('resize', checkMobile);
    };
  });

  useEffect(() => {
    if (scenarioStep !== 21) return;

    setNavContent('about');
    OpenContent();
    OpenAbout();

  }, [scenarioStep]);

  useEffect(() => {
    const muteToggle = document.querySelector('.nav-sound-mute');
    muteToggle.style.textDecoration = isMute ? 'line-through' : 'none';
  }, [isMute]);

  return (
    <nav className={'nav-show'}
      style={navStyle}>
      <div className='home_nav_gradient_bg'></div>
      <a href='/' className="nav_logo-hitbox" style={navLogoHitboxStyle}
        onClick={(e) => {
          // e.preventDefault();
          // OpenHome();
        }}>
      </a>
      <ul className='nav-list' style={navLeftStyle}>
        <li className={`nav-btn ${navContent === 'about' ? 'active' : ''}`}>
          <a href=''
            onClick={(e) => {
              e.preventDefault();
              setNavContent('about');
              OpenContent();
              OpenAbout();
              // setMoveToCamera("about");
            }}>ABOUT</a></li>
        <li className={`nav-btn ${navContent === 'work' ? 'active' : ''}`}>
          <a href=''
            onClick={(e) => {
              e.preventDefault();
              setNavContent('work');
              OpenContent();
              OpenWork();
              // setMoveToCamera("work");
            }}>WORK</a></li>
        <li className={`nav-btn ${navContent === 'contact' ? 'active' : ''}`}>
          <a href=''
            onClick={(e) => {
              e.preventDefault();
              setNavContent('contact');
              OpenContent();
              OpenContact();
              // setMoveToCamera("contact");
            }}>CONTACT</a></li>
      </ul>
      <ul className='nav-mbile-btn' onClick={(e) => {
        isNavOpen ? setNavOpen(false) : setNavOpen(true);
      }}>
        <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 20 20" fill="none">
          <path d="M3.3335 4.16699H16.6668" stroke="black" strokeWidth="2" />
          <path d="M3.3335 10H16.6668" stroke="black" strokeWidth="2" />
          <path d="M3.3335 15.833H16.6668" stroke="black" strokeWidth="2" />
        </svg>
      </ul>
      <ul className='nav-list_right'
        style={navRightStyle}>
        <li>
          <a href="/"
            className={'nav-black nav-btn nav-sound-mute'}
            onClick={(e) => {
              e.preventDefault();
              setMute(isMute ? false : true);
            }}>BGM</a>
        </li>
        <li>
          <a href="/"
            className={'nav-black nav-btn nav-laguage-sel'}
            onClick={(e) => {
              e.preventDefault();
              setLang(lang === 'ENG' ? 'KOR' : 'ENG');
              console.log('lang', lang, lang === 'ENG');
            }}>{lang}</a>
        </li>
        <li >
          <a href={lang === 'ENG' ? `${process.env.PUBLIC_URL}/data/HNINE_INTERACTION_ENG.pdf` : `${process.env.PUBLIC_URL}/data/HNINE_INTERACTION_KOR.pdf`} download className="profile">
            <div>PROFILE</div>
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
              <path d="M9.99984 1.6665V14.9998M9.99984 14.9998L3.33325 9.44428M9.99984 14.9998L16.6665 9.44428M3.33336 18.3332L16.6666 18.3332" stroke="black" strokeWidth="1.5" />
            </svg>
          </a>
        </li>
      </ul>
      <button className='nav_close-btn'
        style={closeBtnStyle}
        onClick={(e) => {
          closeSubToMain();
        }}>
        <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 20 20" fill="none">
          <path d="M16.6663 3.33301L3.33301 16.6663" stroke="black" strokeWidth="2" />
          <path d="M16.6663 16.667L3.33301 3.33366" stroke="black" strokeWidth="2" />
        </svg>
      </button>
      <NavMobile
        isNavOpen={isNavOpen}
        onClickMenu={onClickMenu}
        navContent={navContent}
        setNavOpen={setNavOpen}
        lang={lang}
        setLang={setLang}
      />
    </nav>
  );
};

export default Navbar
